"use client";

import { GRID_CLASSES } from "@/libs/grid/grid";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import { ArrowLeft, ArrowRight } from "lucide-react";

import "swiper/css";
import "swiper/css/navigation";

const services = [
  {
    num: "1",
    title: "AI Customer Support",
    desc: "Provide instant, accurate customer support across WhatsApp, your website, and other digital channels—24 hours a day.",
  },
  {
    num: "2",
    title: "AI Sales Agents",
    desc: "Engage prospects, answer product questions, recommend solutions, and guide customers through the buying journey.",
  },
  {
    num: "3",
    title: "AI Lead Generation",
    desc: "Capture, qualify, and route high-quality leads automatically so your sales team spends more time closing deals.",
  },
  {
    num: "4",
    title: "AI Workflow Automation",
    desc: "Automate repetitive business processes, connect your systems, and streamline day-to-day operations.",
  },
  {
    num: "5",
    title: "AI Scheduling & Booking",
    desc: "Manage appointments, bookings, confirmations, and reminders without manual coordination.",
  },
  {
    num: "6",
    title: "Custom AI Solutions",
    desc: "Design and deploy bespoke AI systems tailored to your business processes, industry, and growth objectives.",
  },
];

export default function OurSolutions() {
    return (
        <div className={`${GRID_CLASSES} relative grid grid-cols-12 w-full md:pt-28 md:pb-14`}>
            <span className="col-start-1 col-span-3 md:text-base">Our Solutions</span>
            <h2 className="col-start-5 col-span-8 md:text-4xl">
                Every business is different. That&apos;s why<span className="text-accent"> we design AI systems around your workflows, goals, and existing technology</span>—not the other way around.
            </h2>

            <div className="col-span-12 mt-12 relative">
                <Swiper
                    modules={[Navigation]}
                    navigation={{
                        prevEl: ".solutions-prev",
                        nextEl: ".solutions-next",
                    }}
                    spaceBetween={24}
                    slidesPerView={1.2}
                    breakpoints={{
                        640: { slidesPerView: 2, spaceBetween: 24 },
                        1024: { slidesPerView: 3, spaceBetween: 24 },
                        1280: { slidesPerView: 4, spaceBetween: 24 },
                    }}
                    className="w-full"
                >
                    {services.map((service, index) => (
                        <SwiperSlide key={service.num} className="h-auto!">
                            <div
                                className={`flex flex-col gap-24 px-6 py-6 h-full rounded-2xl ${
                                    index % 2 === 0 ? "bg-accent" : "bg-offWhite/30 text-white"
                                }`}
                            >
                                <span className="text-6xl">{service.num}</span>
                                <div className="flex flex-col space-y-4">
                                    <h3 className="text-xl font-medium">
                                        {service.title}
                                    </h3>
                                    <p className="text-sm leading-relaxed">
                                        {service.desc}
                                    </p>
                                </div>  
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

                <div className="flex justify-end gap-3 mt-6">
                    <button
                        className="solutions-prev p-3 rounded-full border border-white/20 text-white transition-colors hover:bg-white/10 disabled:opacity-30"
                        aria-label="Previous slide"
                    >
                        <ArrowLeft size={18} />
                    </button>
                    <button
                        className="solutions-next p-3 rounded-full border border-white/20 text-white transition-colors hover:bg-white/10 disabled:opacity-30"
                        aria-label="Next slide"
                    >
                        <ArrowRight size={18} />
                    </button>
                </div>
            </div>
        </div>
    )
}